import * as React from 'react';

const ChevronDown12: React.FC<React.SVGProps<SVGSVGElement>> = () => (
	<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'>
		<path
			d='M9.46973 3.46979C9.76262 3.17689 10.2374 3.17689 10.5303 3.46979C10.8231 3.76269 10.8231 4.23746 10.5303 4.53033L6.53027 8.53033C6.2374 8.82321 5.76262 8.82317 5.46973 8.53033L1.46973 4.53033C1.17683 4.23744 1.17683 3.76268 1.46973 3.46979C1.76262 3.17689 2.23738 3.17689 2.53027 3.46979L6 6.93951L9.46973 3.46979Z'
			fill='currentColor'
		/>
	</svg>
);

export default ChevronDown12;
